module.exports = __webpack_public_path__ + "static/media/01_MEDS-1.5-S-12 1.d9e5daf3.svg";